import { FC, useEffect } from 'react';
import Button from '~/components/Button/Button';
import { getStore } from '~/mobx/AppStore';
import VoteSummaryModal from './VoteSummaryModal/VoteSummaryModal';
import { observer } from 'mobx-react';

interface Props {
    isDisabledVote: boolean;
    remainingExtraVoteQuantity?: number;
    onClick: (isClicked: boolean) => void;
}

const VoteSummary: FC<Props> = (props: Props) => {
    const { isDisabledVote = false, remainingExtraVoteQuantity = 0, onClick } = props;

    const containerClassName = 'sticky-extra-vote fixed bottom-0 left-0 right-0 z-10 bg-cover bg-center bg-no-repeat';
    const contentClassName =
        'relative mx-auto flex items-center justify-between px-[15px] py-[15px] md:py-[25px] max-w-[540px] md:max-w-[720px] mdLandscape:max-w-[960px] lg:max-w-[1320px]';
    const buttonClassName = '!min-w-[130px] md:!min-w-[170px]';

    return (
        <div
            className={containerClassName}
            style={{ backgroundImage: "url('/img/bg/bg-summary-vote.png')" }}
            id="sticky-extra-vote"
        >
            <div className={contentClassName}>
                {remainingExtraVoteQuantity > 0 && !isDisabledVote && (
                    <div className="message text-sm md:text-base">{`Du har ${remainingExtraVoteQuantity} ekstrastemmer igjen`}</div>
                )}
                <div className="ml-auto text-right">
                    <Button
                        btnText={'Gå videre'}
                        testId={'btn-open-vote-summary'}
                        onClick={() => onClick(true)}
                        disabled={isDisabledVote}
                        extendedClassName={buttonClassName}
                    />
                </div>
                <VoteSummaryModal />
            </div>
        </div>
    );
};

const VoteSummaryWithStore = observer(() => {
    const { candidateStore, ballotStore, voteStore, previewStore } = getStore();
    const isPreview = previewStore.isInitialized;
    const isDisabledVote = candidateStore.isDisabledVote || isPreview;
    const extraVoteQuantity = Number(ballotStore.region?.regionExtraVoteQuantity);

    useEffect(() => {
        if (extraVoteQuantity > 0) {
            voteStore.setRemainingExtraVotesQuota(extraVoteQuantity);
        }
    }, [extraVoteQuantity, voteStore]);

    return (
        <VoteSummary
            isDisabledVote={isDisabledVote}
            remainingExtraVoteQuantity={voteStore.remainingExtraVotesQuota}
            onClick={(isClicked: boolean) => candidateStore.setIsOpenVoteSummaryModal(isClicked)}
        />
    );
});

export default VoteSummaryWithStore;
